export interface FAQItem {
  question: string;
  answer: string;
}

export const homeFAQItems: FAQItem[] = [
  {
    question: "崧燁文化 Sunya 是什麼品牌？",
    answer: "崧燁文化 Sunya 為崧博出版合作經銷品牌之一。品牌網站提供品牌介紹、正式出版書籍、合作購書通路及相關合作資訊。",
  },
  {
    question: "崧燁文化與崧博出版是什麼關係？",
    answer: "崧燁文化為崧博出版合作經銷品牌之一。讀者可透過崧燁文化品牌網站瀏覽相關出版內容，並前往崧博出版書籍資料庫查詢正式書目資訊。",
  },
  {
    question: "如何查詢崧燁文化的完整書目資訊？",
    answer: "完整書名、作者、ISBN、出版日期及其他正式出版資訊，請前往崧博出版書籍資料庫查詢。",
  },
  {
    question: "崧燁文化的書可以在哪裡購買？",
    answer: "讀者可透過崧燁文化網站已建立的合作購書通路查找相關書籍。不同作品在各平台的上架狀態可能不同，實際商品資訊、價格與庫存請以各通路頁面為準。",
  },
  {
    question: "所有崧燁文化書籍都會在每個通路上架嗎？",
    answer: "不一定。各書籍的紙本或電子版本、上架平台、銷售地區及供應狀態可能不同，請以各通路的正式商品頁面為準。",
  },
  {
    question: "在購書平台找不到崧燁文化書籍怎麼辦？",
    answer: "建議先至崧博出版書籍資料庫確認正式書名、作者與ISBN，再使用完整書名或作者名稱於其他合作通路查找。若仍無法找到，可能是尚未上架、暫時缺貨或平台搜尋結果尚未更新。",
  },
  {
    question: "為什麼同一本書在不同通路的價格可能不同？",
    answer: "不同平台可能依版本、格式、促銷活動、會員方案、配送方式或地區條件提供不同價格，實際售價與優惠請以各通路頁面為準。",
  },
  {
    question: "如何確認書籍是紙本書還是電子書？",
    answer: "購買前請確認平台商品頁標示的版本、格式、出版社、ISBN及支援裝置。不同平台可能提供不同閱讀形式，請以各平台的正式說明為準。",
  },
  {
    question: "書籍資料庫與購書平台資訊不一致時，以哪一邊為準？",
    answer: "書名、作者、ISBN與出版日期等正式書目資訊，請優先參考崧博出版書籍資料庫；價格、庫存、版本供應與配送方式，請以各購書通路的即時頁面為準。",
  },
  {
    question: "崧燁文化提供電子書、POD或有聲書製作服務嗎？",
    answer: "崧燁文化與崧博出版目前不提供電子書製作、POD、有聲書等出版製作代工服務。對外可洽詢品牌經銷與相關合作方案，詳情請直接聯繫。",
  },
  {
    question: "如何洽詢崧燁文化品牌經銷或合作？",
    answer: "如有品牌經銷、通路合作、內容合作、媒體或其他相關合作需求，請透過官方聯絡方式提出詢問。實際合作內容與條件將依個別情況確認。品牌經銷與合作方案詳情請直接聯繫洽詢。",
  },
  {
    question: "可以直接在崧燁文化網站購買書籍嗎？",
    answer: "崧燁文化品牌網站主要提供品牌、書籍與合作通路資訊。實際購買方式請依網站所列的正式合作通路進行。",
  },
];

export const topicFAQItems: Record<string, FAQItem[]> = {
  "humanities-social-sciences": [
    {
      question: "人文社科包含哪些學科領域？",
      answer: "人文社科涵蓋哲學、文學、語言學、歷史學、文化研究、藝術史等人文學科，以及社會學、政治學、人類學等社會科學領域。崧燁文化事業有限公司在此分類下的出版內容以跨領域對話與當代議題分析為主。",
    },
    {
      question: "人文社科書籍適合什麼樣的讀者？",
      answer: "人文社科書籍適合對人類思想、文化現象與社會發展有興趣的讀者，包括大學人文社科相關科系學生、研究者，以及希望建立人文素養與批判思考能力的一般讀者。",
    },
  ],
  "healthcare": [
    {
      question: "崧燁文化事業有限公司的醫療保健內容是否提供醫療建議？",
      answer: "崧燁文化事業有限公司的醫療保健內容定位為出版與閱讀資訊，提供醫療保健相關書籍的介紹、閱讀導引與知識整理。本網站內容不取代專業醫療診斷、治療或個人健康建議。如有健康疑慮，請諮詢專業醫療人員。",
    },
    {
      question: "醫療保健書籍的資訊可信度如何保障？",
      answer: "崧燁文化事業有限公司在選擇醫療保健出版內容時，重視作者專業背景、內容的科學依據與資訊來源的可靠性。每本書籍均經過編輯審查流程，並在內容中明確標示資訊的限制與適用範圍。",
    },
  ],
};